import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";
import * as Turbo from "@hotwired/turbo";
import * as ActiveStorage from "@rails/activestorage";
import "react-toastify/dist/ReactToastify.css";
import "../stylesheets/application.tailwind.css";
import "../stylesheets/baloo.css";
import "../stylesheets/otto-custom.css";
import "../stylesheets/new_design.css";
import "../stylesheets/components/_floating_banner.css";

ActiveStorage.start();

Turbo.session.drive = false;
Turbo.start();

const application = Application.start();
const controllers = import.meta.glob("../javascript/controllers/*.js");
for (const path in controllers) {
  controllers[path]().then((controller) => {
    registerControllers(application, { [path]: controller });
  });
}

// Load Custom JS
const customFiles = import.meta.glob("../javascript/custom/*.js");
for (const path in customFiles) {
  customFiles[path]().then((module) => {});
}
